import { useDispatch } from "react-redux";
import { StateDispatch } from "../state";

export const useCustomDispatch = () => useDispatch<StateDispatch>();
